import React from "react";
import { Select } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";
import { useAuth } from "shared/contexts/AuthProvider";
import { useUserOrg } from "shared/contexts/UserOrgContext";
import "./OrgSwitcher.css";
import logger from "shared/utils/logging";

/**
 * OrgSwitcher
 *
 * A compact org selector for the sidebar. Reads from / writes to UserOrgContext.
 * Hidden entirely when the sidebar is collapsed or user is not authenticated.
 *
 * Props:
 *  - collapsed: boolean — when true, renders nothing
 */
const OrgSwitcher = ({ collapsed }) => {
  const { isAuthenticated } = useAuth();
  const { userOrgs, selectedOrg, setSelectedOrg, loading } = useUserOrg();

  if (collapsed || !isAuthenticated || userOrgs.length === 0) {
    return null;
  }

  const options = userOrgs.map((entry) => ({
    value: entry.organization?.org_id,
    label: entry.organization?.name,
  }));

  const handleChange = (orgId) => {
    const entry = userOrgs.find((e) => e.organization?.org_id === orgId);
    if (entry) {
      setSelectedOrg(entry);
    }
  };

  logger.log("OrgSwitcher render", { selectedOrg, options });

  return (
    <div
      style={{
        padding: "8px",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          marginBottom: "6px",
          color: "rgba(255, 255, 255, 0.65)",
          fontSize: "12px",
        }}
      >
        <ApartmentOutlined />
        <span>Organization</span>
      </div>
      <Select
        size="small"
        loading={loading}
        value={selectedOrg?.organization?.org_id ?? undefined}
        onChange={handleChange}
        options={options}
        className="org-switcher-select"
        style={{ width: "100%" }}
        popupMatchSelectWidth={false}
        // variant="filled"
      />
    </div>
  );
};

export default OrgSwitcher;
